// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5AXEi","tenantSelect":"styles_tenantSelect__WxYhj","tenantSelectPopup":"styles_tenantSelectPopup__FBHuq","switchOverlay":"styles_switchOverlay__APj17"};